import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLowestPrice = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_497_98",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			className: "custom-rect",
			width: 20,
			height: 20,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_497_98)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.45842 4.41675V13.5017L5.19071 9.23404L4.41675 10.0001L10.0001 15.5834L15.5834 10.0001L14.8095 9.23404L10.5417 13.5017V4.41675H9.45842Z",
			fill: "currentColor"
		})
	})]
});
export default SvgLowestPrice;
